import { Injectable } from '@angular/core';

import { PassengerInformationInputModalCommonService } from './passenger-information-input-modal.common.service';
import { PassengerInformationInputModalEditArea } from '@common/helpers/constants/my-booking/passenger-information-input-modal.constant';
import { GetOrderResponseDataContactsRepresentative } from 'src/sdk-servicing/model/getOrderResponseDataContactsRepresentative';
import {
  DuringStayInformationData,
  DuringStayInformationParts,
} from '@common/interfaces/mybooking/modals/passenger-information-input/during-stay-information.interface';

/**
 * 現地連絡先情報 service
 */
@Injectable()
export class DuringStayInformationService {
  constructor(private _s04CommonSvc: PassengerInformationInputModalCommonService) {}

  /**
   * 現地連絡先情報 初期値の作成
   * @param representative 代表者連絡先情報
   * @returns 現地連絡先情報 初期値
   */
  createData(representative: GetOrderResponseDataContactsRepresentative): DuringStayInformationData {
    return {
      contacts: representative.contactsDuringStay?.map((contact) => contact.number ?? '') ?? [],
      isError: false,
    };
  }

  /**
   * 現地連絡先情報 設定値の作成
   * @param representative 代表者連絡先情報
   * @returns 現地連絡先情報 設定値
   */
  createParts(representative: GetOrderResponseDataContactsRepresentative): DuringStayInformationParts {
    const isEditMode = this._s04CommonSvc.isEditMode(PassengerInformationInputModalEditArea.DESTINATION_ADDRESS);
    const isRegistered = (representative?.contactsDuringStay && representative.contactsDuringStay.length > 0) ?? false;
    const registrationLabel = this._s04CommonSvc.getRegistrationLabel(isEditMode, isRegistered);
    const registrationClass = this._s04CommonSvc.getRegistrationLabelClass(registrationLabel);

    return {
      isDisplay: false,
      // 現地連絡先情報編集可否
      isEditDuringStayInfo: (representative?.contactsDuringStay ?? []).length < 3,
      registrationLabel: registrationLabel,
      registrationClass: registrationClass,
    };
  }
}
